export default function IosLoopStrong() {
  return (
    <div
      className="ion-icon-ios-loop-strong"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<g>
		<path d="M256,48c-75.033,0-144.531,40.658-181.373,106.107l-1.963,3.485l20.915,11.771l1.962-3.485
			C128.138,107.973,189.621,72,256,72c101.458,0,184,82.542,184,184c0,12.509-1.262,25.007-3.749,37.147l-0.803,3.918l23.511,4.819
			l0.804-3.919C462.574,284.244,464,270.125,464,256C464,141.309,370.691,48,256,48z"/>
		<path d="M416.459,346.119C383.862,404.027,322.379,440,256,440c-101.458,0-184-82.542-184-184c0-12.512,1.262-25.011,3.75-37.15
			l0.803-3.918l-23.511-4.819l-0.804,3.918C49.426,227.75,48,241.87,48,256c0,114.691,93.309,208,208,208
			c75.033,0,144.531-40.658,181.373-106.109l1.963-3.485l-20.915-11.771L416.459,346.119z"/>
	</g>
	<polygon points="384,256 448,320 512,256 	"/>
	<polygon points="0,256 64,192 128,256 	"/>
</g>
</svg>
`,
      }}
    />
  )
}
